import {
    ADMIN_SET_EMAIL_VALID_STATE,
    ADMIN_SET_FNAME_VALID_STATE,
    ADMIN_SET_IS_EDITABLE,
    ADMIN_SET_LNAME_VALID_STATE,
    ADMIN_SET_USER_DATA,
    ADMIN_CLEAR_VALID_STATE,
    REQUEST_ADMIN_GET_ALL_USERS_FAILED,
    RECEIVE_ADMIN_GET_ALL_USERS,
    REQUEST_ADMIN_GET_ALL_USERS,
    RECEIVE_ADMIN_SAVE_USER,
    REQUEST_ADMIN_SAVE_USER,
    REQUEST_ADMIN_SAVE_USER_FAILED,
    ADMIN_SET_SEARCH_PARAMS,
    RECEIVE_ADMIN_DELETE_USER,
    REQUEST_ADMIN_DELETE_USER,
    REQUEST_ADMIN_DELETE_USER_FAILED
} from '../../../actions/truckLoadRate/admin/manageUsersActions';
import { TCXSearchParam, TCXUser } from '../../../../interfaces/TCXInterfaces';

interface AdminManageUsers {
    validState: TCXUser;
    userData: TCXUser;
    allUsers: TCXUser[];
    searchParam: TCXSearchParam;
    isFetchingAllUsers: boolean;
    isEditable: boolean;
    isFormValid: boolean;
    isSavingUser: boolean;
    isDeletingUser: boolean;
}

const manageUserInitialState: AdminManageUsers = {
    validState: {},
    userData: {},
    allUsers: [],
    searchParam: {
        page: 1,
        size: 10
    },
    isFetchingAllUsers: false,
    isEditable: false,
    isFormValid: true,
    isSavingUser: false,
    isDeletingUser: false
};

const manageUserReducer = (manageUserState: AdminManageUsers = manageUserInitialState, action: any): AdminManageUsers => {
    switch (action.type) {
        case ADMIN_CLEAR_VALID_STATE: {
            return {
                ...manageUserState,
                validState: {},
                isFormValid: true
            };
        }
        case ADMIN_SET_USER_DATA: {
            return {
                ...manageUserState,
                userData: action.payload
            };
        }
        case ADMIN_SET_IS_EDITABLE: {
            return {
                ...manageUserState,
                isEditable: action.payload
            };
        }
        case ADMIN_SET_EMAIL_VALID_STATE: {
            return {
                ...manageUserState,
                validState: {
                    ...manageUserState.validState,
                    email: action.payload
                },
                isFormValid: manageUserState.isFormValid && !action.payload
            };
        }
        case ADMIN_SET_FNAME_VALID_STATE: {
            return {
                ...manageUserState,
                validState: {
                    ...manageUserState.validState,
                    firstName: action.payload
                },
                isFormValid: manageUserState.isFormValid && !action.payload
            };
        }
        case ADMIN_SET_LNAME_VALID_STATE: {
            return {
                ...manageUserState,
                validState: {
                    ...manageUserState.validState,
                    lastName: action.payload
                },
                isFormValid: manageUserState.isFormValid && !action.payload
            };
        }
        case RECEIVE_ADMIN_GET_ALL_USERS: {
            return {
                ...manageUserState,
                allUsers: action.payload,
                isFetchingAllUsers: false
            };
        }
        case REQUEST_ADMIN_GET_ALL_USERS_FAILED: {
            return {
                ...manageUserState,
                allUsers: [],
                isFetchingAllUsers: false
            };
        }
        case REQUEST_ADMIN_GET_ALL_USERS: {
            return {
                ...manageUserState,
                allUsers: [],
                isFetchingAllUsers: true
            };
        }
        case RECEIVE_ADMIN_SAVE_USER: {
            return {
                ...manageUserState,
                userData: {
                    email: '',
                    firstName: '',
                    lastName: '',
                    status: '',
                    id: ''
                },
                validState: {},
                isEditable: false,
                isFormValid: true,
                isSavingUser: false
            };
        }
        case REQUEST_ADMIN_SAVE_USER_FAILED: {
            return {
                ...manageUserState,
                isSavingUser: false
            };
        }
        case REQUEST_ADMIN_SAVE_USER: {
            return {
                ...manageUserState,
                isSavingUser: true
            };
        }
        case ADMIN_SET_SEARCH_PARAMS: {
            return {
                ...manageUserState,
                searchParam: action.payload
            };
        }
        case RECEIVE_ADMIN_DELETE_USER: {
            return {
                ...manageUserState,
                isDeletingUser: false
            };
        }
        case REQUEST_ADMIN_DELETE_USER_FAILED: {
            return {
                ...manageUserState,
                isDeletingUser: false
            };
        }
        case REQUEST_ADMIN_DELETE_USER: {
            return {
                ...manageUserState,
                isDeletingUser: true
            };
        }
        default:
            return manageUserState;
    }
};

export default manageUserReducer;
